import { useIntl } from '@/intl'
import { mqMin, space } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import React, { useState } from 'react'
import { styled } from 'styled-components'
import { InWebsiteLanguageFilter } from './InWebsiteLanguageFilter'
import { PartyCompositionFilter } from './PartyCompositionFilter'
import { SortingSelect } from './SortingSelect'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`

const PartyCompositionFilterWrapper = styled.div`
  display: none;
  margin-bottom: ${space('primitives_space_12')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    display: block;
  }
`

export function Filters() {
  const [reviewsAmount, setReviewsAmount] = useState<number | null>(null)
  const intl = useIntl()

  return (
    <Wrapper>
      <PartyCompositionFilterWrapper>
        <PartyCompositionFilter setReviewsAmount={setReviewsAmount} />
      </PartyCompositionFilterWrapper>
      <Content>
        {reviewsAmount && (
          <Typography $variant="body-m-bold-tight" $color="semantics_content_secondary_color">
            {intl.formatMessage({ id: 'reviews_amount_heading' }, { amount: reviewsAmount })}
          </Typography>
        )}
        <SortingSelect />
      </Content>
      <InWebsiteLanguageFilter />
    </Wrapper>
  )
}
